export default __webpack_public_path__ + "ColladaLoader-28d48dcb5b915e4b2e50c04ab612109c.js";